!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.perPage = 5, this.currentReviewPage = 0, this.sortBy = "date", this.sortDirection = "desc", 
      this.reviewImages = [], this.imageUrlsSet = new Set, this.sortingConfig = {
        elastic_search_score: {
          sort_by: "_score",
          ascending: !1
        },
        badge: {
          sort_by: "reviewer_type",
          ascending: !1
        },
        score: {
          sort_by: "score",
          ascending: !1
        },
        low_score: {
          sort_by: "score",
          ascending: !0
        },
        date: {
          sort_by: "date",
          ascending: !1
        },
        votes: {
          sort_by: "votes_up",
          ascending: !1
        },
        low_votes: {
          sort_by: "votes_down",
          ascending: !1
        },
        images: {
          sort_by: "image_count",
          ascending: !1
        },
        grouping: {
          sort_by: "grouping_originated",
          ascending: !0
        }
      }, this.appkey = this.dataset.appkey, this.options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }, this.domCache = {}, this.dateFormatter = new Intl.DateTimeFormat("en-GB", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
      });
    }
    connectedCallback() {
      this.appkey ? (this.cacheDOMElements(), this.init(), this.addEventListener("click", this.onClickHandler.bind(this)), 
      this.addEventListener("change", this.onChangeHandler.bind(this))) : this.hide();
    }
    cacheDOMElements() {
      this.domCache = {
        rating: this.querySelector("[data-rating]"),
        totalReview: this.querySelector("[data-total-review]"),
        sortLabel: this.querySelector("[data-sort-label]"),
        reviewsLoader: this.querySelector("[data-reviews-loader]"),
        reviews: this.querySelector("[data-reviews]"),
        reviewTemplate: this.querySelector("template[data-template-review]"),
        imageContainer: this.querySelector("[data-review-images]"),
        imageGrid: this.querySelector("[data-review-images-grid]"),
        fitIndicator: this.querySelector("[data-fit-indicator]"),
        fitDot: this.querySelector("[data-fit-dot]"),
        topics: this.querySelectorAll("[data-topic]")
      };
    }
    show() {
      this.closest(".max-h-0")?.classList.remove("max-h-0"), document.querySelector("#Reviews details")?.classList.remove("hidden");
    }
    hide() {
      const e = this.closest(".shopify-section");
      e && e.parentNode.removeChild(e);
    }
    loadStart(e) {
      e?.classList.add("opacity-50", "cursor-wait", "pointer-events-none");
    }
    loadEnd(e) {
      e?.classList.remove("opacity-50", "cursor-wait", "pointer-events-none");
    }
    onChangeHandler(e) {
      (e.target?.hasAttribute("data-sort") || "sort_by" === e.target?.name) && (e.preventDefault(), 
      this.sortBy = e.target.value, this.sortDirection = e.target.selectedOptions[0]?.dataset.direction || "desc", 
      this.domCache.sortLabel && (this.domCache.sortLabel.textContent = e.target.selectedOptions[0]?.textContent || ""), 
      this.resetImages(), this.getReviews());
    }
    onClickHandler(e) {
      e.target.hasAttribute("data-reviews-loader") && (e.preventDefault(), this.getReviews(this.currentReviewPage + 1));
    }
    resetImages() {
      this.reviewImages = [], this.imageUrlsSet.clear();
    }
    collectReviewImages(e) {
      e.forEach(e => {
        e.images_data && e.images_data.length > 0 && e.images_data.forEach(t => {
          this.imageUrlsSet.has(t.thumb_url) || (this.imageUrlsSet.add(t.thumb_url), this.reviewImages.push({
            thumb_url: t.thumb_url,
            original_url: t.original_url,
            review_title: e.title || "",
            review_score: e.score || 0,
            user_name: e.user?.display_name || ""
          }));
        });
      });
    }
    createImageElement(e, t, s = "aspect-square", i = {}) {
      const a = document.createElement("div");
      a.className = s, Object.entries(i).forEach(([e, t]) => {
        a.setAttribute(e, t);
      });
      const r = document.createElement("img");
      return r.src = e.thumb_url, r.alt = t, r.className = "w-full h-full object-cover", 
      r.loading = "lazy", a.appendChild(r), a;
    }
    renderReviewImages() {
      if (!this.domCache.imageContainer || !this.domCache.imageGrid || 0 === this.reviewImages.length) return;
      this.domCache.imageGrid.innerHTML = "";
      const e = document.createDocumentFragment();
      this.reviewImages.forEach(t => {
        const s = this.createImageElement(t, `Customer photo from ${t.user_name}`, "aspect-square slide w-1/4 tablet:w-[32%]", {
          "data-slide": ""
        });
        e.appendChild(s);
      }), this.domCache.imageGrid.appendChild(e), this.domCache.imageContainer.classList.remove("hidden");
    }
    renderIndividualReviewImages(e, t) {
      const s = e.querySelector("[data-review-image-container]"), i = e.querySelector("[data-review-images-individual]");
      s && i && t.images_data && 0 !== t.images_data.length && (i.innerHTML = "", t.images_data.slice(0, 4).forEach(e => {
        const s = this.createImageElement(e, `Customer photo from ${t.user?.display_name || "customer"}`);
        i.appendChild(s);
      }), s.classList.remove("hidden"));
    }
    renderFitIndicator(e) {
      if (!this.domCache.fitIndicator || !this.domCache.fitDot || !e?.custom_fields_bottomline) return void this.domCache.fitIndicator?.classList.add("hidden");
      const t = Object.values(e.custom_fields_bottomline).find(e => "Size" === e.type && "Size" === e.title);
      if (!t || !t.average_score) return void this.domCache.fitIndicator.classList.add("hidden");
      const s = (Math.max(1, Math.min(3, t.average_score)) - 1) / 2 * 100;
      this.domCache.fitDot.style.left = `calc(${s}% - 6px)`, this.domCache.fitIndicator.classList.remove("hidden");
    }
    updateCounts(e) {
      this.total = e.pagination?.total || e.bottomline?.total_review || "", this.pages = Math.ceil(this.total / this.perPage);
    }
    renderSection(e) {
      this.updateCounts(e), this.domCache.rating && (this.domCache.rating.textContent = e.bottomline?.average_score ? e.bottomline.average_score.toFixed(1) : ""), 
      this.domCache.totalReview && (this.domCache.totalReview.textContent = this.total), 
      this.renderFitIndicator(e.bottomline);
    }
    renderReviews(e) {
      if (this.updateCounts(e), this.currentReviewPage || this.renderSection(e), this.currentReviewPage = e.pagination.page, 
      1 == this.currentReviewPage && (this.domCache.reviews.innerHTML = "", this.resetImages()), 
      0 === e.reviews.length) return;
      this.collectReviewImages(e.reviews), 1 === this.currentReviewPage && this.renderReviewImages();
      const t = document.createDocumentFragment();
      e.reviews.forEach(e => {
        const s = this.domCache.reviewTemplate.content.cloneNode(!0), i = new Date(e.created_at), a = this.dateFormatter.format(i);
        s.children[0].style.setProperty("--score", e.score), s.querySelector("[data-title]").innerHTML = e.title, 
        s.querySelector("[data-content]").innerHTML = e.content, this.renderIndividualReviewImages(s, e), 
        s.querySelector("[data-display-name]").innerHTML = e.user.display_name, s.querySelector("[data-date]").innerHTML = a, 
        e.verified_buyer || s.querySelector("[data-verified]").classList.remove("hidden"), 
        t.appendChild(s);
      }), this.domCache.reviews.appendChild(t), this.currentReviewPage >= this.pages ? this.domCache.reviewsLoader?.classList.add("hidden") : this.domCache.reviewsLoader?.classList.remove("hidden"), 
      this.domCache.topics?.forEach(e => e.ariaCurrent = this.topics?.includes(e.textContent.trim())), 
      this.show();
    }
    async getFilteredReviews(e = 1) {
      const t = new URL(`https://api-cdn.yotpo.com/v1/reviews/${this.appkey}/filter.json`);
      t.searchParams.set("per_page", this.perPage), t.searchParams.set("page", e);
      const s = {
        domain_key: parseInt(this.product.id),
        sortings: [ this.sortingConfig[this.sortBy] ],
        sort: this.sortBy,
        ascending: !1,
        pictured: !0
      };
      try {
        const e = await fetch(t, {
          ...this.options,
          method: "POST",
          body: JSON.stringify(s)
        }), i = await e.json();
        this.renderReviews(i.response);
      } catch (e) {
        console.error("Error fetching filtered reviews:", e);
      }
    }
    async getReviewsForImages() {
      if (this.reviewImages.length > 0) return;
      const e = new URL(`https://api-cdn.yotpo.com/v1/widget/${this.appkey}/products/${this.dataset.productId}/reviews.json`);
      e.searchParams.set("per_page", 20), e.searchParams.set("page", 1), e.searchParams.set("sort", "images"), 
      e.searchParams.set("direction", "desc");
      try {
        const t = await fetch(e, this.options), s = await t.json();
        s.response && s.response.reviews && (this.collectReviewImages(s.response.reviews), 
        this.renderReviewImages());
      } catch (e) {
        console.error("Error fetching images from reviews:", e);
      }
    }
    async getReviews(e = 1) {
      const t = new URL(`https://api-cdn.yotpo.com/v1/widget/${this.appkey}/products/${this.dataset.productId}/reviews.json`);
      t.searchParams.set("per_page", this.perPage), t.searchParams.set("page", e), t.searchParams.set("sort", this.sortBy), 
      t.searchParams.set("direction", this.sortDirection || "desc");
      try {
        const s = await fetch(t, this.options), i = await s.json();
        this.renderReviews(i.response), 1 === e && await this.getReviewsForImages();
      } catch (e) {
        console.error("Error fetching reviews:", e);
      }
    }
    init() {
      this.product = JSON.parse(this.querySelector('[type="application/json"]').textContent), 
      this.getReviews();
    }
  }
  customElements.get("product-reviews") || customElements.define("product-reviews", e);
}();